import { all } from 'redux-saga/effects';

import transactions from './create';
import dialogs from './dialogs';

function* watch() {
  yield all([transactions.saga.watch(), dialogs.saga.watch()]);
}

export default {
  watch,
};
